module.exports = __webpack_public_path__ + "img/1-1.61300139.png";